import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackRemoveUserFromWishListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/wishList/trackRemoveUserFromWishList";

const useTrackRemoveUserFromWishList = (
    parameters: TrackRemoveUserFromWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.removeUserFromWishList, parameters, options);
};

export default useTrackRemoveUserFromWishList;
